import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as token_model from '@/model/token.js'




export type CreateResult = Pick<token_model.TRawDocType, 'value' | 'refresh' | 'expire'>

export function create (): HttpBodyUnpacking<CreateResult>
{
	// eslint-disable-next-line @stylistic/function-call-spacing
	return http.create
	(
		// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unsafe-assignment
		{ url: '/token', method: 'POST', headers: { 'x-app': process.env.PUBLIC_APPID } },

	)


}


export type UpdateResult = Pick<token_model.TRawDocType, 'value' | 'refresh' | 'expire'>

export function update (refresh: string): HttpBodyUnpacking<UpdateResult>
{
	return http.put('/token', { refresh })

}


export type RetrieveResult
	= Pick<token_model.TRawDocType, 'expire' | 'scope'>
	& Pick<token_model.TVirtuals, 'is_super' | 'mode'>

export function retrieve (): HttpBodyUnpacking<RetrieveResult>
{
	return http.get('/token')

}

